"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const getMobileDetect = (userAgent) => {
    const isAndroid = () => Boolean(userAgent.match(/Android/i));
    const isIos = () => Boolean(userAgent.match(/iPhone|iPad|iPod/i));
    const isOpera = () => Boolean(userAgent.match(/Opera Mini/i));
    const isWindows = () => Boolean(userAgent.match(/IEMobile/i));
    const isSSR = () => Boolean(userAgent.match(/SSR/i));
    const isMobile = () => Boolean(isAndroid() || isIos() || isOpera() || isWindows());
    const isDesktop = () => Boolean(!isMobile() && !isSSR());
    const isTablet = () => Boolean(userAgent.match(/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i));
    return {
        isMobile,
        isDesktop,
        isAndroid,
        isIos,
        isSSR,
        isTablet,
    };
};
const useMobileDetect = () => {
    const userAgent = typeof navigator === "undefined" ? "SSR" : navigator.userAgent;
    return getMobileDetect(userAgent);
};
exports.default = useMobileDetect;
//# sourceMappingURL=useMobileDetect.js.map